export default __webpack_public_path__ + "static/TierOne-c6e442ac099240b380b0d799ff34045e.webp";